import React from "react";
import { connect } from "react-redux";
import i_symbol from "../../../assets/common_imgs/i_symbol.png";
import ABC_NT_i_img from "../../../assets/games/AB_classic_Non_timer/i.svg";
import img2x from "../../../assets/common_imgs/2x.svg";
import img4x from "../../../assets/common_imgs/4x.svg";
import snd from "../../../assets/sounds/bet.mp3"
import { Howl } from "howler";
class payOutInfo extends React.Component {
    constructor(props) {

        super(props)
        this.state = {
            payoutInfo: [],
            isPayout_show: false,
            gameId: 0,
            isActiveWindowsMode: null,
            isActivePortraitMode: null,
            isActiveLandscapeMode: null

        }
        // this.snd = new Audio(snd);
        this.payoutIconSound = this.initializepayoutIconSound();
        this.cardGames = [28, 34, 30, 32, 33, 35, 36, 37, 38, 39, 29, 40, 42, 50, 51, 53]
    }

    initializepayoutIconSound = () => {
        let chipSound = new Howl({
            src: [snd],
            html5: true, // Enable HTML5 Audio for mobile compatibility
        });

        return chipSound
    }

    componentDidMount() {
        const { childRef } = this.props;
        childRef(this);
        this.handleOrientationChange();
        window.addEventListener("resize", this.handleResize);
    }



    handleResize = () => {
        this.handleOrientationChange()
    }

    handleOrientationChange = () => {
        const isActiveWindowsMode =
            (navigator.userAgentData && navigator.userAgentData.platform && navigator.userAgentData.platform === "Windows") ||
            (navigator.userAgent.indexOf("Windows") !== -1) || (navigator.platform.includes("Mac") && !("ontouchend" in document || navigator.maxTouchPoints > 0));
        const isActivePortraitMode = window.innerHeight > window.innerWidth;
        const isActiveLandscapeMode = window.innerWidth > window.innerHeight;

        this.setState({
            isActiveWindowsMode,
            isActivePortraitMode: !isActiveWindowsMode && isActivePortraitMode,
            isActiveLandscapeMode: !isActivePortraitMode && isActiveLandscapeMode,

        });

        const infoIconElement = document.getElementById("infoIcon");
        const winratiopopelement = document.getElementById("winratiopop")


        switch (Number(this.state.gameId)) {
            case 1:
                infoIconElement.className = ""
                infoIconElement.style.cssText = ""
                if (this.state.isActivePortraitMode) {
                    document.getElementById("infoIcon").classList.add('fc_payTabl_portrait')
                    document.getElementById("winratiopop").style.top = "300px";
                    document.getElementById("winratiopop").style.right = "120px";
                    document.getElementById("winratiopop").style.zIndex = 999;
                } else {
                    document.getElementById("infoIcon").classList.add('fc_payTable');
                    document.getElementById("winratiopop").style.top = "200px";
                    document.getElementById("winratiopop").style.right = "500px";
                    document.getElementById("winratiopop").style.zIndex = 999;

                }
                break
            case 2:
                infoIconElement.className = ""
                winratiopopelement.style.cssText = ""
                winratiopopelement.style.zIndex = 9999;

                if (this.state.isActivePortraitMode) {
                    infoIconElement.classList.add('ftt_payTableport');
                    document.getElementById("winratiopop").style.top = "259px";
                    document.getElementById("winratiopop").style.right = "120px";
                    document.getElementById("winratiopop").style.zIndex = 99;


                } else {
                    infoIconElement.classList.add('ftt_payTable');
                    document.getElementById("winratiopop").style.top = "100px";
                    document.getElementById("winratiopop").style.right = "500px";
                    document.getElementById("winratiopop").style.zIndex = 9999;

                }

                break;

            case 3:
                infoIconElement.className = ""
                infoIconElement.style.cssText = ""
                winratiopopelement.style.zIndex = 9999;

                if (this.state.isActivePortraitMode) {
                    document.getElementById("winratiopop").style.top = "600px";
                    document.getElementById("winratiopop").style.right = "120px";
                    document.getElementById("winratiopop").style.zIndex = 9999;
                    document.getElementById("infoIcon").classList.add('artimer_payTable')


                } else {
                    document.getElementById("infoIcon").classList.add('artimer_payTable')
                    document.getElementById("winratiopop").style.top = "200px";
                    document.getElementById("winratiopop").style.right = "500px";
                    document.getElementById("winratiopop").style.zIndex = 9999;

                }
                break;

            case 5:
                infoIconElement.className = ""
                infoIconElement.style.cssText = ""
                winratiopopelement.style.zIndex = 9999;

                if (this.state.isActivePortraitMode) {
                    infoIconElement.classList.add('ft_payTableport');
                    document.getElementById("winratiopop").style.top = "300px";
                    document.getElementById("winratiopop").style.right = "120px";
                    document.getElementById("winratiopop").style.zIndex = 9999;


                } else {
                    infoIconElement.classList.add('ft_payTable');
                    document.getElementById("winratiopop").style.top = "100px";
                    document.getElementById("winratiopop").style.right = "500px";
                    document.getElementById("winratiopop").style.zIndex = 9999;


                }

                break;

            case 6:
            case 13:
                if (this.state.isActivePortraitMode) {
                    document.getElementById("infoIcon").classList.add('arnt_payTable')
                    document.getElementById("winratiopop").style.top = "600px";
                    document.getElementById("winratiopop").style.right = "120px";
                    document.getElementById("winratiopop").style.zIndex = 9999;

                } else {
                    document.getElementById("infoIcon").classList.add('arnt_payTable')
                    document.getElementById("winratiopop").style.top = "100px";
                    document.getElementById("winratiopop").style.right = "500px";
                    document.getElementById("winratiopop").style.zIndex = 9999;
                }
                break
            case 12:
                infoIconElement.className = ""
                infoIconElement.style.cssText = ""
                winratiopopelement.style.zIndex = 9999;
                if (this.state.isActivePortraitMode) {
                    document.getElementById("infoIcon").classList.add('ertimer_payTable')
                    document.getElementById("winratiopop").style.top = "600px";
                    document.getElementById("winratiopop").style.right = "120px";
                    document.getElementById("winratiopop").style.zIndex = 9999;
                } else {
                    document.getElementById("infoIcon").classList.add('ertimer_payTable')
                    document.getElementById("winratiopop").style.top = "200px";
                    document.getElementById("winratiopop").style.right = "500px";
                    document.getElementById("winratiopop").style.zIndex = 9999;
                }
                break

            case 25:
                infoIconElement.className = ""
                infoIconElement.style.cssText = ""
                winratiopopelement.style.zIndex = 9999;

                if (this.state.isActivePortraitMode) {
                    infoIconElement.classList.add('bingo_payTablepport');

                    document.getElementById("winratiopop").classList.add('bingo_popuptblport');
                    document.getElementById("winratiopop").style.top = "18px";
                    document.getElementById("winratiopop").style.right = "15px";
                    document.getElementById("winratiopop").style.zIndex = 99;


                } else {
                    infoIconElement.classList.add('bingo_payTable');
                    document.getElementById("winratiopop").style.top = "100px";
                    document.getElementById("winratiopop").style.right = "500px";
                    document.getElementById("winratiopop").style.zIndex = 99;

                }

                break;
            case 26:
                infoIconElement.className = ""
                infoIconElement.style.cssText = ""
                winratiopopelement.style.zIndex = 9999;
                if (this.state.isActivePortraitMode) {
                    infoIconElement.classList.add('kn_payTableport');
                    document.getElementById("winratiopop").style.top = "300px";
                    document.getElementById("winratiopop").style.right = "120px";
                    document.getElementById("winratiopop").style.zIndex = 999;

                } else {
                    infoIconElement.classList.add('kn_payTable');
                    document.getElementById("winratiopop").style.top = "200px";
                    document.getElementById("winratiopop").style.right = "500px";
                    document.getElementById("winratiopop").style.zIndex = 999;
                }
                break;
            case 19:
                infoIconElement.className = ""
                infoIconElement.style.cssText = ""
                winratiopopelement.style.zIndex = 9999;
                if (this.state.isActivePortraitMode) {
                    infoIconElement.classList.add('sorat_payTable_portrait');
                    winratiopopelement.style.top = "200px";
                    winratiopopelement.style.right = "100px";

                } else {
                    infoIconElement.classList.add('art_payTable')
                    winratiopopelement.style.top = "105px";
                    winratiopopelement.style.right = "655px";

                }
                break;
            case 23:
                infoIconElement.className = ""
                infoIconElement.style.cssText = ""
                winratiopopelement.style.zIndex = 9999;
                if (this.state.isActivePortraitMode) {
                    infoIconElement.classList.add('mw_payTable_portrait')
                    winratiopopelement.style.top = "300px";
                    winratiopopelement.style.right = "120px";

                } else {
                    infoIconElement.classList.add('mw_payTable')

                    winratiopopelement.style.top = "200px";
                    winratiopopelement.style.right = "500px";


                }
                break;
            case 7:
            case 14:
                infoIconElement.className = ""
                infoIconElement.style.cssText = ""
                winratiopopelement.style.zIndex = 9999;
                if (this.state.isActivePortraitMode) {
                    infoIconElement.classList.add('mtt_payTable_portrait')

                    winratiopopelement.style.top = "140px"
                    winratiopopelement.style.right = "120px"
                } else {

                    infoIconElement.classList.add('mtt_payTable')
                    winratiopopelement.style.top = "101px"
                    winratiopopelement.style.right = "429px"
                }
                break;
            case 24:
            case 41:
                infoIconElement.className = ""
                infoIconElement.style.cssText = ""
                if (this.state.isActivePortraitMode) {
                    infoIconElement.classList.add('ab_payTable')
                    infoIconElement.classList.add('emptyPointer')
                    winratiopopelement.style.top = "340px";
                    winratiopopelement.style.right = "120px";
                    winratiopopelement.style.zIndex = 99;
                } else {
                    infoIconElement.classList.add('ab_payTable')
                    winratiopopelement.style.top = "300px";
                    winratiopopelement.style.right = "500px";
                    winratiopopelement.style.zIndex = 99;
                }
                break;
            // case 42:
            //     infoIconElement.className = ""
            //     infoIconElement.style.cssText = ""
            //     if (this.state.isActivePortraitMode) {
            //         infoIconElement.classList.add('abc_payTable')
            //         infoIconElement.classList.add('emptyPointer')
            //         winratiopopelement.style.top = "340px";
            //         winratiopopelement.style.right = "120px";
            //         winratiopopelement.style.zIndex = 99;
            //     } else {
            //         infoIconElement.classList.add('abc_payTable')
            //         winratiopopelement.style.top = "300px";
            //         winratiopopelement.style.right = "500px";
            //         winratiopopelement.style.zIndex = 99;
            //     }
            //     break;
            default:
                break
        }

    }

    setPayoutData(payoutData, gameId) {

        if (document.getElementById("infoIcon")) {
            document.getElementById("infoIcon").className = "";

        }


        this.setState({
            payoutInfo: payoutData,
            gameId: gameId
        })
        // console.log(payoutData);
        // console.log(gameId);
        if (document.getElementById("winratiopop")) {
            document.getElementById("winratiopop").style.top = "0px";
            document.getElementById("winratiopop").style.right = "0px";
        }

        switch (Number(gameId)) {
            case 1:

                if (document.getElementById("infoIcon").classList.contains("fc_payTable")) {
                    document.getElementById("infoIcon").classList.remove('fc_payTable')
                }
                if (this.props.isMobile) {
                    document.getElementById("infoIcon").classList.add('fc_payTable')
                    document.getElementById("infoIcon").classList.add('emptyPointer')

                } else {

                    document.getElementById("infoIcon").classList.add('fc_payTable')
                }


                if (this.state.isActivePortraitMode) {
                    document.getElementById("infoIcon").classList.add('fc_payTabl_portrait')
                    document.getElementById("winratiopop").style.top = "300px";
                    document.getElementById("winratiopop").style.right = "120px";
                    document.getElementById("winratiopop").style.zIndex = 999;
                } else {
                    document.getElementById("infoIcon").classList.add('fc_payTable');
                    document.getElementById("winratiopop").style.top = "200px";
                    document.getElementById("winratiopop").style.right = "500px";
                    document.getElementById("winratiopop").style.zIndex = 999;

                }

                break;
            case 2:
                if (document.getElementById("infoIcon").classList.contains("ftt_payTable")) {
                    document.getElementById("infoIcon").classList.remove('ftt_payTable')
                }
                if (this.props.isMobile) {
                    document.getElementById("infoIcon").classList.add('ftt_payTable')
                    document.getElementById("infoIcon").classList.add('emptyPointer')

                } else {
                    document.getElementById("infoIcon").classList.add('ftt_payTable')
                }

                if (this.state.isActivePortraitMode) {

                    document.getElementById("infoIcon").classList.add('ftt_payTableport')
                    document.getElementById("winratiopop").style.top = "259px";
                    document.getElementById("winratiopop").style.right = "120px";
                    document.getElementById("winratiopop").style.zIndex = 99;


                } else {
                    document.getElementById("winratiopop").style.top = "100px";
                    document.getElementById("winratiopop").style.right = "500px";
                    document.getElementById("winratiopop").style.zIndex = 9999;

                }

                break;



            case 12:
                if (document.getElementById("infoIcon").classList.contains("ertimer_payTable")) {
                    document.getElementById("infoIcon").classList.remove('ertimer_payTable')
                }
                if (this.props.isMobile) {
                    document.getElementById("infoIcon").classList.add('ertimer_payTable')
                    document.getElementById("infoIcon").classList.add('emptyPointer')
                } else {
                    document.getElementById("infoIcon").classList.add('ertimer_payTable')
                }

                if (this.state.isActivePortraitMode) {
                    document.getElementById("infoIcon").classList.add('ertimer_payTable')
                    document.getElementById("winratiopop").style.top = "600px";
                    document.getElementById("winratiopop").style.right = "120px";
                    document.getElementById("winratiopop").style.zIndex = 9999;
                } else {
                    document.getElementById("infoIcon").classList.add('ertimer_payTable')
                    document.getElementById("winratiopop").style.top = "200px";
                    document.getElementById("winratiopop").style.right = "500px";
                    document.getElementById("winratiopop").style.zIndex = 9999;
                }


                break;


            case 19:
                if (document.getElementById("infoIcon").classList.contains("art_payTable")) {
                    document.getElementById("infoIcon").classList.remove('art_payTable')
                }
                if (this.props.isMobile) {
                    document.getElementById("infoIcon").classList.add('art_payTable')
                    document.getElementById("infoIcon").classList.add('emptyPointer')
                } else {
                    document.getElementById("infoIcon").classList.add('art_payTable')
                }
                if (this.state.isActivePortraitMode) {


                    document.getElementById("infoIcon").classList.add('sorat_payTable_portrait');
                    document.getElementById("winratiopop").style.top = "200px";
                    document.getElementById("winratiopop").style.right = "100px";
                    document.getElementById("winratiopop").style.zIndex = 99;

                } else {
                    document.getElementById("infoIcon").classList.add('art_payTable')
                    document.getElementById("winratiopop").style.top = "105px";
                    document.getElementById("winratiopop").style.right = "655px";
                    document.getElementById("winratiopop").style.zIndex = 9999;

                }

                break;
            case 3:
                if (document.getElementById("infoIcon").classList.contains("artimer_payTable")) {
                    document.getElementById("infoIcon").classList.remove('artimer_payTable')
                }
                if (this.props.isMobile) {
                    document.getElementById("infoIcon").classList.add('artimer_payTable')
                    document.getElementById("infoIcon").classList.add('emptyPointer')
                } else {
                    document.getElementById("infoIcon").classList.add('artimer_payTable')
                }



                if (this.state.isActivePortraitMode) {
                    document.getElementById("winratiopop").style.top = "600px";
                    document.getElementById("winratiopop").style.right = "120px";
                    document.getElementById("winratiopop").style.zIndex = 9999;
                    document.getElementById("infoIcon").classList.add('artimer_payTable')


                } else {
                    document.getElementById("infoIcon").classList.add('artimer_payTable')
                    document.getElementById("winratiopop").style.top = "200px";
                    document.getElementById("winratiopop").style.right = "500px";
                    document.getElementById("winratiopop").style.zIndex = 9999;

                }

                break;

            case 5:
                if (document.getElementById("infoIcon").classList.contains("ft_payTable")) {
                    document.getElementById("infoIcon").classList.remove('ft_payTable')
                }
                if (this.props.isMobile) {
                    document.getElementById("infoIcon").classList.add('ft_payTable')
                    document.getElementById("infoIcon").classList.add('emptyPointer')
                } else {
                    document.getElementById("infoIcon").classList.add('ft_payTable');
                }


                if (this.state.isActivePortraitMode) {
                    document.getElementById("infoIcon").classList.add('ft_payTableport');
                    // document.getElementById("winratiopop").style.top = "24px";
                    // document.getElementById("winratiopop").style.right = "-118px";
                    document.getElementById("winratiopop").style.top = "300px";
                    document.getElementById("winratiopop").style.right = "120px"
                    document.getElementById("winratiopop").style.zIndex = 9999;



                } else {
                    document.getElementById("winratiopop").style.top = "100px";
                    document.getElementById("winratiopop").style.right = "500px";
                    document.getElementById("winratiopop").style.zIndex = 9999;

                }


                break;
            case 6:
            case 13:
                if (document.getElementById("infoIcon").classList.contains("arnt_payTable")) {
                    document.getElementById("infoIcon").classList.remove('arnt_payTable')
                }
                if (this.props.isMobile) {
                    document.getElementById("infoIcon").classList.add('arnt_payTable')
                    document.getElementById("infoIcon").classList.add('emptyPointer')
                } else {
                    document.getElementById("infoIcon").classList.add('arnt_payTable')
                }

                if (this.state.isActivePortraitMode) {
                    document.getElementById("infoIcon").classList.add('arnt_payTable')
                    document.getElementById("winratiopop").style.top = "600px";
                    document.getElementById("winratiopop").style.right = "120px";
                    document.getElementById("winratiopop").style.zIndex = 9999;

                } else {
                    document.getElementById("infoIcon").classList.add('arnt_payTable')
                    document.getElementById("winratiopop").style.top = "100px";
                    document.getElementById("winratiopop").style.right = "500px";
                    document.getElementById("winratiopop").style.zIndex = 9999;
                }

                break;

            case 7:
            case 14:
                if (document.getElementById("infoIcon").classList.contains("mtt_payTable")) {
                    document.getElementById("infoIcon").classList.remove('mtt_payTable')
                }
                if (this.props.isMobile) {
                    document.getElementById("infoIcon").classList.add('mtt_payTable')
                    document.getElementById("infoIcon").classList.add('emptyPointer')

                } else {
                    document.getElementById("infoIcon").classList.add('mtt_payTable')
                }

                if (this.state.isActivePortraitMode) {
                    document.getElementById("infoIcon").classList.add('mtt_payTable_portrait')

                    document.getElementById("infoIcon").classList.add('mtt_payTable')
                    document.getElementById("winratiopop").style.top = "140px"
                    document.getElementById("winratiopop").style.right = "120px"
                } else {

                    document.getElementById("infoIcon").classList.add('mtt_payTable')
                    document.getElementById("winratiopop").style.top = "101px"
                    document.getElementById("winratiopop").style.right = "429px"
                }

                break;
            case 20:
                if (document.getElementById("infoIcon")?.classList.contains("dt_payTable")) {
                    document.getElementById("infoIcon").classList.remove('dt_payTable')
                }
                if (this.props.isMobile) {
                    document.getElementById("infoIcon").classList.add('dt_payTable')
                    document.getElementById("infoIcon").classList.add('emptyPointer')

                } else {
                    document.getElementById("infoIcon").classList.add('dt_payTable')
                }
                document.getElementById("winratiopop").style.top = "300px";
                document.getElementById("winratiopop").style.right = "500px";
                document.getElementById("winratiopop").style.zIndex = 9999;

                break;
            case 26:
                if (document.getElementById("infoIcon")?.classList.contains("kn_payTable")) {
                    document.getElementById("infoIcon")?.classList.remove('kn_payTable')
                }
                if (this.props.isMobile) {
                    document.getElementById("infoIcon")?.classList.add('kn_payTable')
                    document.getElementById("infoIcon")?.classList.add('emptyPointer')

                } else {
                    document.getElementById("infoIcon")?.classList.add('kn_payTable')
                }


                if (this.state.isActivePortraitMode) {

                    document.getElementById("winratiopop").style.top = "300px";
                    document.getElementById("winratiopop").style.right = "120px";
                    document.getElementById("winratiopop").style.zIndex = 999;

                } else {

                    document.getElementById("winratiopop").style.top = "200px";
                    document.getElementById("winratiopop").style.right = "500px";
                    document.getElementById("winratiopop").style.zIndex = 999;
                }




                break
            case 23:
                if (document.getElementById("infoIcon").classList.contains("mw_payTable")) {
                    document.getElementById("infoIcon").classList.remove('mw_payTable')
                }
                if (this.props.isMobile) {
                    document.getElementById("infoIcon").classList.add('mw_payTable')
                    document.getElementById("infoIcon").classList.add('emptyPointer')

                } else {
                    document.getElementById("infoIcon").classList.add('mw_payTable')
                }

                if (this.state.isActivePortraitMode) {
                    document.getElementById("infoIcon").classList.add('mw_payTable_portrait')

                    document.getElementById("winratiopop").style.top = "300px";
                    document.getElementById("winratiopop").style.right = "120px";
                    document.getElementById("winratiopop").style.zIndex = 99;
                } else {
                    document.getElementById("infoIcon").classList.add('mw_payTable')

                    document.getElementById("winratiopop").style.top = "200px";
                    document.getElementById("winratiopop").style.right = "500px";
                    document.getElementById("winratiopop").style.zIndex = 99;
                }

                break
            case 24:
            case 41:
                if (document.getElementById("infoIcon").classList.contains("ab_payTable")) {
                    document.getElementById("infoIcon").classList.remove('ab_payTable')
                }
                if (this.props.isMobile) {
                    document.getElementById("infoIcon").classList.add('ab_payTable')
                    document.getElementById("infoIcon").classList.add('emptyPointer')

                } else {
                    document.getElementById("infoIcon").classList.add('ab_payTable')
                }
                document.getElementById("winratiopop").style.top = "300px";
                document.getElementById("winratiopop").style.right = "-337px";
                document.getElementById("winratiopop").style.zIndex = 99;

                if (this.state.isActivePortraitMode) {
                    document.getElementById("infoIcon").classList.add('ab_payTable')
                    document.getElementById("infoIcon").classList.add('emptyPointer')
                    document.getElementById("winratiopop").style.top = "340px";
                    document.getElementById("winratiopop").style.right = "120px";
                    document.getElementById("winratiopop").style.zIndex = 99;
                } else {
                    document.getElementById("infoIcon").classList.add('ab_payTable')
                    document.getElementById("winratiopop").style.top = "300px";
                    document.getElementById("winratiopop").style.right = "500px";
                    document.getElementById("winratiopop").style.zIndex = 99;
                }

                break;
            case 25:
                if (document.getElementById("infoIcon").classList.contains("bingo_payTable")) {
                    document.getElementById("infoIcon").classList.remove('bingo_payTable')
                }
                if (this.props.isMobile) {
                    document.getElementById("infoIcon").classList.add('bingo_payTable')
                    document.getElementById("infoIcon").classList.add('emptyPointer')

                } else {
                    document.getElementById("infoIcon").classList.add('bingo_payTable')
                }

                if (this.state.isActivePortraitMode) {
                    document.getElementById("winratiopop").classList.add('bingo_popuptblport');
                    document.getElementById("infoIcon").classList.add('bingo_payTablepport');
                    document.getElementById("winratiopop").style.top = "18px";
                    document.getElementById("winratiopop").style.right = "15px";
                    document.getElementById("winratiopop").style.zIndex = 99;


                } else {

                    document.getElementById("winratiopop").style.top = "100px";

                    document.getElementById("winratiopop").style.right = "500px";
                    document.getElementById("winratiopop").style.zIndex = 99;

                }

                break;
            case 28:
            case 29:
            case 30:
            case 32:
            case 33:
            case 35:
            case 36:
            case 37:
            case 38:
            case 39:
            case 40:
            case 34:
            case 42:
            case 50:
            case 51:
            case 53:

                if (document.getElementById("payPage")) {
                    document.getElementById("payPage").display = "none"
                    clearTimeout(this.payoutTimerId);

                }

                break;
            // case "kn_dup":
            //     if (document.getElementById("infoIcon").classList.contains("kn_payTable")) {
            //         document.getElementById("infoIcon").classList.remove('kn_payTable')
            //     }
            //     if (this.props.isMobile) {
            //         document.getElementById("infoIcon").classList.add('kn_payTable')
            //         document.getElementById("infoIcon").classList.add('emptyPointer')

            //     } else {
            //         document.getElementById("infoIcon").classList.add('kn_payTable')
            //     }
            //     document.getElementById("winratiopop").style.top = "100px";
            //     document.getElementById("winratiopop").style.right = "180px";
            //     document.getElementById("winratiopop").style.zIndex = 9999;
            //     break
            // case "bngo_dup":
            //     if (document.getElementById("infoIcon").classList.contains("bgno_dup_payTable")) {
            //         document.getElementById("infoIcon").classList.remove('bgno_dup_payTable')
            //     }
            //     if (this.props.isMobile) {
            //         document.getElementById("infoIcon").classList.add('bgno_dup_payTable')
            //         document.getElementById("infoIcon").classList.add('emptyPointer')

            //     } else {
            //         document.getElementById("infoIcon").classList.add('bgno_dup_payTable')
            //     }
            //     document.getElementById("winratiopop").style.top = "100px";
            //     document.getElementById("winratiopop").style.right = "180px";
            //     document.getElementById("winratiopop").style.zIndex = 9999;
            //     break
            // case 42:
            //     if (document.getElementById("infoIcon").classList.contains("abc_payTable")) {
            //         document.getElementById("infoIcon").classList.remove('abc_payTable')
            //     }
            //     if (this.props.isMobile) {
            //         document.getElementById("infoIcon").classList.add('abc_payTable')
            //         document.getElementById("infoIcon").classList.add('emptyPointer')

            //     } else {
            //         document.getElementById("infoIcon").classList.add('abc_payTable')
            //     }
            //     document.getElementById("winratiopop").style.top = "300px";
            //     document.getElementById("winratiopop").style.right = "-337px";
            //     document.getElementById("winratiopop").style.zIndex = 99;

            //     if (this.state.isActivePortraitMode) {
            //         document.getElementById("infoIcon").classList.add('abc_payTable')
            //         document.getElementById("infoIcon").classList.add('emptyPointer')
            //         document.getElementById("winratiopop").style.top = "340px";
            //         document.getElementById("winratiopop").style.right = "120px";
            //         document.getElementById("winratiopop").style.zIndex = 99;
            //     } else {
            //         document.getElementById("infoIcon").classList.add('abc_payTable')
            //         document.getElementById("winratiopop").style.top = "300px";
            //         document.getElementById("winratiopop").style.right = "500px";
            //         document.getElementById("winratiopop").style.zIndex = 99;
            //     }

            //     break;
            default:
                break;
        }


        const activeStatus = this.cardGames.includes(Number(gameId));


        this.payoutTimerId = setTimeout(() => {
            // if(document.getElementById("payPage")&&gameId !== 28&&gameId !== 30)
            if (document.getElementById("payPage") && !activeStatus)
                document.getElementById("payPage").style.display = "block";
        }, 500)

    }

    addwinrationtble2() {
        if (document.getElementById("winratiopop")) {
            document.getElementById("winratiopop").style.display = "none";
            this.setState({ isPayout_show: false })
        }
    }


    addwinrationtble() {

        let portrait = window.innerHeight > window.innerWidth;
        let newClassname = ""
        switch (this.state.gameId) {
            case 3: newClassname = "art_winratiopop"; break;
            case 6: newClassname = "arnt_winratiopop"; break;
            case 13: newClassname = "ernt_winratiopop"; break;
            case 12: newClassname = "ert_winratiopop"; break;
            case 20: newClassname = "dtt_winratiopop"; break;
            default: newClassname = ""; break;
        }
        if (!this.state.isPayout_show) {
            if (document.getElementById("winratiopop")) {
                document.getElementById("winratiopop").classList.add("arnt_winratio");
                if (portrait && newClassname) {
                    document.getElementById("winratiopop").classList.add(newClassname);
                }
                document.getElementById("winratiopop").style.display = "block";
            }
            // if (document.getElementById("payPage")) {
            //     document.getElementById("payPage").classList.add("main_pop_up_full")
            // }
            this.setState({ isPayout_show: true })
        } else {
            if (document.getElementById("winratiopop")) {
                document.getElementById("winratiopop").classList.remove("arnt_winratio")
                if (portrait && newClassname) {
                    document.getElementById("winratiopop").classList.remove(newClassname);
                }
                document.getElementById("winratiopop").style.display = "none";
            }
            // if (document.getElementById("payPage")) {
            //     document.getElementById("payPage").classList.remove("main_pop_up_full")
            // }
            this.setState({ isPayout_show: false })
        }
    }

    hidewinrationtble() {
        if (this.state.isPayout_show && navigator.userAgentData.platform == "Windows") {
            if (document.getElementById("winratiopop")) {
                document.getElementById("winratiopop").classList.remove("arnt_winratio")
                document.getElementById("winratiopop").style.display = "none";
            }
            this.setState({ isPayout_show: false })
        }
    }

    show2xImg(val) {
        // console.log(val);
        // document.getElementById("img2x").style.display = "block";
    }

    render() {
        const cover = (document.getElementById("winratiopop")?.style?.display === undefined || document.getElementById("winratiopop")?.style?.display === "") ? "none" : document.getElementById("winratiopop")?.style?.display
        //  const cover=document.getElementById("winratiopop")?.style?.display
        // console.log(cover)
        return (
            <>
                {<div className="cover" style={{ width: "100%", height: "2350px", position: "absolute", inset: "0", zIndex: "100000", display: cover, background: "rgb(0,0,0,0.6)" }}
                    onClick={(e) => { e.preventDefault(); this.addwinrationtble(); this.payoutIconSound.play(); }}
                // onPointerDown={(e) => { e.preventDefault(); this.addwinrationtble() }}

                // onMouseLeave={(e) => { e.preventDefault(); this.hidewinrationtble() }}
                // onMouseOut={(e) => { e.preventDefault(); this.hidewinrationtble() }}

                ></div>}

                <div id="payPage" className="PayoutPage" onClick={(e) => {
                    e.preventDefault(); this.addwinrationtble();
                    // this.snd.play(); 
                    // this.payoutIconSound.play(); 
                }}>
                    <div id="infoIcon" className={(this.props.isMobile) ? 'emptyPointer' : ''}
                        onClick={(e) => {
                            e.preventDefault(); this.addwinrationtble();
                            //  this.snd.play(); 
                            this.payoutIconSound.play();
                        }}
                    // onPointerDown={(e) => { e.preventDefault(); this.addwinrationtble() }}

                    // onMouseLeave={(e) => { e.preventDefault(); this.hidewinrationtble() }}
                    // onMouseOut={(e) => { e.preventDefault(); this.hidewinrationtble() }}
                    >
                        <img className={(this.props.isMobile) ? 'i_symbol emptyPointer' : 'i_symbol'} src={i_symbol} />
                    </div>
                    <div className='payout_table' id="winratiopop" >
                        <table id="payTable" className={(this.props.isMobile) ? 'payTable emptyPointer' : 'payTable'}>
                            <tbody>
                                <tr id="tableHead">
                                    <th className="payout_head" >{this.state.gameId == 26 ? "Numbers Matched" : "Win Combination"}</th>
                                    <th className="payout_head">Prize</th>
                                </tr>
                            </tbody>
                            <tbody>
                                {this.state.payoutInfo.map((item, index) => (
                                    <tr key={index}>
                                        <td >
                                            {/* {item.key} */}
                                            {item.key == "2x" ? <img id="img2x" className="bonusImg" src={img2x} alt="2X"></img> : ""}
                                            {item.key == "4x" ? <img id="img4x" className="bonusImg" src={img4x} alt="4X"></img> : ""}
                                            {item.key !== "2x" && item.key != "4x" ? item.key : ""}

                                        </td>
                                        <td >
                                            {item.value}

                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </>
        )
    }
}

const mapStatesToProps = (state) => {
    return {
        language: state.languageObjs.languageObj
    }
}

export default connect(mapStatesToProps)(payOutInfo) 